import { Action } from '@ngrx/store';
import { Filter } from '@app/core/models/Filters/Filter';
import { Product } from '@app/products/models/product';

export enum FindOrderPlinthBlocksActionTypes {
  LoadProducts = '[Find Order PlinthBlocks] Load Products',
  LoadProductsSuccess = '[Find Order PlinthBlocks] Load Products Success',
  LoadProductsFailure = '[Find Order PlinthBlocks] Load Products Failure',
  LoadOrderPlinthBlocks = '[Find Order PlinthBlocks] Load Order Plinth Blocks',
  CountOrderPlinthBlocks = '[Find Order Operations] Count Order Plinth Blocks',
  ExportOrderPlinthBlocks = '[Find Order Operations] Export Order Plinth Blocks',
}

export class LoadOrderPlinthBlocks implements Action {
  readonly type = FindOrderPlinthBlocksActionTypes.LoadOrderPlinthBlocks;

  constructor(public payload: Filter) {}
}

export class CountOrderPlinthBlocks implements Action {
  readonly type = FindOrderPlinthBlocksActionTypes.CountOrderPlinthBlocks;

  constructor(public payload: Filter) {}
}

export class LoadProducts implements Action {
  readonly type = FindOrderPlinthBlocksActionTypes.LoadProducts;

  constructor(public payload: Filter) {}
}

export class LoadProductsSuccess implements Action {
  readonly type = FindOrderPlinthBlocksActionTypes.LoadProductsSuccess;

  constructor(public payload: Product[]) {}
}

export class LoadProductsFailure implements Action {
  readonly type = FindOrderPlinthBlocksActionTypes.LoadProductsFailure;

  constructor(public payload: Error[]) {}
}

export class ExportOrderPlinthBlocks implements Action {
  readonly type = FindOrderPlinthBlocksActionTypes.ExportOrderPlinthBlocks;
}

export type FindOrderPlinthBlocksActionsUnion =
  | LoadOrderPlinthBlocks
  | CountOrderPlinthBlocks
  | LoadProducts
  | LoadProductsSuccess
  | LoadProductsFailure
  | ExportOrderPlinthBlocks;
